import { Component } from '@angular/core';
import { ButtonDirective, ButtonIcon, ButtonLabel } from 'primeng/button';
import { Tag } from 'primeng/tag';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-error-404-page',
  imports: [Tag, ButtonDirective, ButtonIcon, ButtonLabel, RouterLink],
  templateUrl: './error-404-page.component.html',
  styleUrl: './error-404-page.component.scss',
})
export class Error404PageComponent {
  goBack() {
    window.history.back();
  }
}
